/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function LoginAttemptEntryFromJSON(json) {
    return LoginAttemptEntryFromJSONTyped(json, false);
}
export function LoginAttemptEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'time': !exists(json, 'time') ? undefined : (new Date(json['time'])),
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
    };
}
export function LoginAttemptEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'time': value.time === undefined ? undefined : (value.time.toISOString()),
        'ip': value.ip,
    };
}
